import { useCallback } from 'react';
import { SceneWithUserNames } from '../../../../types/scene.types';
import { SortConfig } from '../../BreakdownMain/BreakdownMain.types';
import { sortScenes } from '../../BreakdownMain/Utils/SceneCodeUtils';

interface UseSceneCodeValidationParams {
  /** 设置场次列表 */
  setScenes: React.Dispatch<React.SetStateAction<SceneWithUserNames[]>>;
  /** 排序配置 */
  sortConfig: SortConfig;
}

/**
 * 场号验证 Hook
 * 负责处理场号输入完成后的排序
 */
export const useSceneCodeValidation = ({
  setScenes,
  sortConfig,
}: UseSceneCodeValidationParams) => {
  /**
   * 处理场次编号输入完成后的排序（当用户离开输入框时触发）
   * @param sceneId 场次ID
   */
  const handleSceneCodeBlur = useCallback((sceneId: string) => {
    // 执行排序
    setScenes(prev => {
      const sorted = sortScenes([...prev], sortConfig.key, sortConfig.direction);
      return sorted;
    });
  }, [sortConfig, setScenes]);

  return {
    handleSceneCodeBlur,
  };
};


